module.exports = __webpack_public_path__ + "media/images/v2/overlay-8612a63a0ba79f3bcbe4c77be17326cb.png";